import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { Flex, Fieldset } from "@base-ui/containers";
import { IconButton } from "@base-ui/buttons";
import { InputContainer, Range1, Range2 } from "./multiRange.styles";
import { Label } from "../rangeCommon.styles";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox"];
var MultiRangeInput = function MultiRangeInput(props) {
  var id = props.id,
    legend = props.legend,
    label1 = props.label1,
    label2 = props.label2,
    steps = props.steps,
    values = props.values,
    _onChange = props.onChange,
    onStep = props.onStep,
    disabled = props.disabled,
    hideLegend = props.hideLegend,
    className = props.className;
  var diff = Math.max.apply(Math, _toConsumableArray(values)) - Math.min.apply(Math, _toConsumableArray(values));
  var width = diff / steps * 100 || 0;
  var offset = Math.min.apply(Math, _toConsumableArray(values)) / diff * 100 || 0;
  var handleStep = function handleStep(a, b) {
    var newValues = [a, b];
    if (a < 0) newValues[0] = 0;
    if (a > steps) newValues[0] = steps;
    if (b > steps) newValues[1] = steps;
    if (b < 0) newValues[1] = 0;
    onStep(newValues);
  };
  return /*#__PURE__*/_jsx(Fieldset, _objectSpread(_objectSpread({
    className: className,
    hideLegend: hideLegend,
    legend: legend
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: /*#__PURE__*/_jsxs(Flex.Row, {
      children: [/*#__PURE__*/_jsx(IconButton, {
        className: "step-back",
        role: "slider",
        icon: "expandLeft",
        inverted: true,
        label: "Stega bak\xE5t",
        "aria-valuemin": 0,
        "aria-valuemax": steps,
        "aria-valuenow": values[0],
        "aria-valuetext": "".concat(label1, " ").concat(label2),
        style: {
          borderRadius: "3px 0 0 3px"
        },
        disabled: disabled || steps === 0 || values[0] === 0 && values[1] === 0,
        onClick: function onClick() {
          return handleStep(values[0] - 1, values[1] - 1);
        }
      }), /*#__PURE__*/_jsxs(Flex.Row, {
        style: {
          position: "relative"
        },
        children: [/*#__PURE__*/_jsxs(InputContainer, {
          children: [/*#__PURE__*/_jsx(Label, {
            htmlFor: "".concat(id, "-from"),
            children: label1
          }), /*#__PURE__*/_jsx(Range1, {
            id: "".concat(id, "-from"),
            "aria-label": label1,
            type: "range",
            min: 0,
            max: steps,
            value: values[0],
            "aria-valuemin": 0,
            "aria-valuemax": steps,
            "aria-valuenow": values[0],
            "aria-valuetext": label1,
            disabled: disabled,
            onChange: function onChange(e) {
              return _onChange("from", parseInt(e.target.value));
            }
          })]
        }), /*#__PURE__*/_jsxs(InputContainer, {
          children: [/*#__PURE__*/_jsx(Label, {
            htmlFor: "".concat(id, "-to"),
            children: label2
          }), /*#__PURE__*/_jsx(Range2, {
            id: "".concat(id, "-to"),
            "aria-label": label2,
            type: "range",
            min: 0,
            max: steps,
            value: values[1],
            "aria-valuemin": 0,
            "aria-valuemax": steps,
            "aria-valuenow": values[1],
            "aria-valuetext": label2,
            width: width,
            offset: offset,
            disabled: disabled,
            onChange: function onChange(e) {
              return _onChange("to", parseInt(e.target.value));
            }
          })]
        })]
      }), /*#__PURE__*/_jsx(IconButton, {
        className: "step-forward",
        role: "slider",
        icon: "expandRight",
        inverted: true,
        label: "Stega fram\xE5t",
        "aria-valuemin": 0,
        "aria-valuemax": steps,
        "aria-valuenow": values[1],
        "aria-valuetext": "".concat(label1, " ").concat(label2),
        style: {
          borderRadius: "0 3px 3px 0"
        },
        disabled: disabled || steps === 0 || values[0] === steps && values[1] === steps,
        onClick: function onClick() {
          return handleStep(values[0] + 1, values[1] + 1);
        }
      })]
    })
  }));
};
MultiRangeInput.propTypes = {
  id: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  label1: PropTypes.string.isRequired,
  label2: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onStep: PropTypes.func.isRequired,
  values: PropTypes.array.isRequired,
  steps: PropTypes.number.isRequired,
  hideLegend: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string
};
export default MultiRangeInput;